export { default } from './TrimSection';
